import React from 'react';
import './Attribution.css';

const Attribution = () => {
  return (
    <div className="map-attribution">
      <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">
        © OpenStreetMap contributors
      </a>
    </div>
  );
};

export default Attribution;
